import { EntityView, Headers } from "../generic";
import type {
  MessageResult,
  NovelHistoryBatchAddParams,
  NovelHistoryBatchRemoveParams,
  NovelHistoryCreateParams,
  NovelHistoryEntity,
  NovelHistoryListParams,
  Result,
} from "../../types";
import { assertSuccess } from "../../core";
import axios from "../../core/axios";

// These are also used for highlights
class NovelHistoryClass extends EntityView<
  NovelHistoryListParams,
  NovelHistoryEntity
> {
  constructor() {
    super("/novel/history");
  }

  // TODO: enquire about flat api
  async create(body: NovelHistoryCreateParams, auth: string) {
    const resp = await axios.post<Result<NovelHistoryEntity>>(
      `/novel/${body.novelChapterId}/history`,
      body,
      {
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data).data;
  }

  async delete(chapterId: string, version: number = 0, auth: string) {
    const resp = await axios.delete<MessageResult>(
      `/novel/${chapterId}/history`,
      {
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data);
  }

  async batchAdd(body: NovelHistoryBatchAddParams, auth: string) {
    const resp = await axios.post<MessageResult<"History Entries added">>(
      this.apiPath + "/batch",
      body,
      {
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data).data;
  }

  async batchRemove(body: NovelHistoryBatchRemoveParams, auth: string) {
    const resp = await axios.delete<MessageResult<"History Entries removed">>(
      this.apiPath + "/batch",
      {
        data: body,
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data);
  }
}

export const NovelHistory = new NovelHistoryClass();
